import { concat, createTheme, ThemeProps, FieldVariant } from "@stackup/inputs"

const build = (name: string, props: ThemeProps, ...names: FieldVariant[]) => {
  const check = props.types.includes("check")
  const condensed = props.variants.includes("condensed")
  const populated = condensed && props.value !== ""
  const problem = props.touched && props.error
  const variants = props.variants.map(
    (variant) => variant && `${name}--${variant}`
  )

  return concat(
    name,
    check && "field--check",
    problem && `${name}--problem`,
    populated && `${name}--populated`,
    ...variants,
    ...names
  )
}

export const theme = createTheme({
  field: (props) => build("field", props),
  error: () => "message message--problem",
  label: (props) => {
    if (!props.types.includes("check")) {
      return build("field__label", props)
    }
  },
  help: (props) => {
    if (!props.types.includes("fieldset")) {
      return build("field__help", props)
    }
  },
  input: (props) => {
    if (!props.types.includes("check")) {
      return build(
        "field__input",
        props,
        props.types.includes("switch") && "toggle-switch"
      )
    }
  },
})
